const SEARCH_BILLING_ENTITIES_REQUEST = 'SEARCH_BILLING_ENTITIES_REQUEST';
const TOGGLE_BILLING_ENTITY_REQUEST = 'TOGGLE_BILLING_ENTITY_REQUEST';

export const searchBillingEntities = (query, billingOnly, callback, includeNonEntities = false) => ({
    type: SEARCH_BILLING_ENTITIES_REQUEST,
    payload: { query, billingOnly, callback, includeNonEntities }
});

export const toggleBillingEntity = (entityType, entityId, billingEntity, callback) => ({
    type: TOGGLE_BILLING_ENTITY_REQUEST,
    payload: { entityType, entityId, billingEntity, callback }
});
